import React from 'react';
import {
    Typography,
    Chip,
} from "@mui/material";

import { _date } from "../../../utils/helpers";

export const ContactFormColumns = () => [
    {
        id: "name",
        label: "Name",
        render: (value, row) => {
            return (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {value}
                </Typography>
            );
        }
    },
    {
        id: "email",
        label: "Email",
        render: (value, row) => {
            return (
                <Typography variant="body2">
                    {value}
                </Typography>
            );
        }
    },
    {
        id: "type",
        label: "Type",
        render: (value, row) => {
            const typeLabels = {
                'contact': 'Contact',
                'free_course': 'Free Course'
            };
            const typeColors = {
                'contact': 'primary',
                'free_course': 'warning'
            };
            return (
                <Chip
                    label={typeLabels[value] || value}
                    color={typeColors[value] || 'default'}
                    size="small"
                />
            );
        }
    },
    {
        id: "status",
        label: "Status",
        render: (value, row) => {
            const statusLabels = {
                'pending': 'Pending',
                'in_progress': 'In Progress',
                'completed': 'Completed',
                'cancelled': 'Cancelled'
            };
            const statusColors = {
                'pending': 'warning',
                'in_progress': 'info',
                'completed': 'success',
                'cancelled': 'error'
            };
            return (
                <Chip
                    label={statusLabels[value] || value}
                    color={statusColors[value] || 'default'}
                    size="small"
                />
            );
        }
    },
    {
        id: "message",
        label: "Message",
        render: (value, row) => {
            const truncated = value && value.length > 100 ? value.substring(0, 100) + '...' : value;
            return (
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {truncated}
                </Typography>
            );
        }
    },
    {
        id: "red_at",
        label: "Read",
        render: (value, row) => {
            return (
                <Chip
                    label={value ? "Read" : "New"}
                    color={value ? "default" : "primary"}
                    size="small"
                />
            );
        }
    },
    {
        id: "created_at",
        label: "Date",
        render: (value, row) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
];
